// components/Layout.js
import React, { createContext, useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import { Box, Container, Typography } from "@mui/material";

export const RootContext = createContext();

const rows = [
  {
    id: "01c1774-7f3d-46ad...90a8",
    type: "deposit",
    amount: 20000,
    balance: 100000,
    date: "10/21/2024 4:19:39 PM",
  },
  {
    id: "02c1774-7f3d-46ad...90a8",
    type: "withdraw",
    amount: 30000,
    balance: 80000,
    date: "10/21/2024 4:19:39 PM",
  },
  {
    id: "03c1774-7f3d-46ad...90a8",
    type: "deposit",
    amount: 30000,
    balance: 50000,
    date: "10/21/2024 4:19:39 PM",
  },
  {
    id: "04c1774-7f3d-46ad...90a8",
    type: "withdraw",
    amount: 20000,
    balance: 80000,
    date: "10/21/2024 4:19:39 PM",
  },
  {
    id: "05c1774-7f3d-46ad...90a8",
    type: "deposit",
    amount: 100000,
    balance: 100000,
    date: "10/21/2024 4:19:39 PM",
  },
];

const Layout = () => {
  const [balances, setBalances] = useState(rows);
  return (
    <RootContext.Provider value={{ balances, setBalances }}>
      <Box
        style={{
          backgroundColor: "#000000",
          minHeight: "100vh",
          color: "white",
        }}
      >
        <Container>
          <Box
            sx={{
              paddingTop: "64px",
            }}
          >
            <Header />
          </Box>
          <main>
            <Outlet />
            {/* This is where the routed components (pages) will be rendered */}
          </main>
          <Box display="flex" justifyContent="center" paddingY={2}>
            <Typography
              variant="body2"
              textAlign="center"
              width="100%"
              color="rgba(97, 97, 97, 1)"
            >
              This is a website demo
            </Typography>
          </Box>
        </Container>
      </Box>
    </RootContext.Provider>
  );
};

export default Layout;
